export enum LegacyReferralNotificationStatusEnum {
  InProgress = 1,
  CancelledStaffed = 2,
  CancelledNtfc = 3,
  CancelledDisciplineRemoved = 4
}

export const LegacyReferralNotificationStatusOptions = [
{ id: 1, label: 'In Progress' },
{ id: 2, label: 'Cancelled - Staffed' },
{ id: 3, label: 'Cancelled - Ntfc' },
{ id: 4, label: 'Cancelled - Discipline Removed' }
];
